import ky, { KyInstance, Options } from 'ky';

export function createHttpClient(
  prefixUrl: string,
  options?: Options,
): KyInstance {
  return ky.create({ prefixUrl, ...options });
}
